import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useWarningButtonStyles } from 'kineticUtils';

const useLaneStyles = makeStyles(({ palette, spacing }) => {
  return createStyles({
    lanesContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingRight: spacing(2),
    },
    laneList: {
      paddingTop: spacing(2),
    },
    laneAccordion: {
      marginTop: spacing(2),
    },
    actionButtons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    warningButton: {
      ...useWarningButtonStyles(palette).contained,
    },
    fullHeight: {
      height: '100%',
    },
    actionButton: {
      margin: spacing(),
    },
    title: {
      marginBottom: spacing(2),
    },
  });
});

export default useLaneStyles;
